import { render } from "./SampleIndex.vue?vue&type=template&id=eff79368"
import script from "./SampleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Sample/SampleIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eff79368"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eff79368', __exports__)) {
    api.reload('eff79368', __exports__)
  }
  
  module.hot.accept("./SampleIndex.vue?vue&type=template&id=eff79368", () => {
    api.rerender('eff79368', render)
  })

}


export default __exports__